import logo from '../assets/images/logo-plumbing3.svg';

const Logo = () => {
 return <img src={logo} alt="jobster logo" className='logo'/>;
}

export default Logo;